// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1vuN4","inner":"Footer_inner__1jJoc"};